module.exports = __webpack_public_path__ + "img/gift4-01-c11-k2.e2d95837.png";